import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'translateArray',
    standalone: false
})
export class TranslateArrayPipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(arr: string[]): string[] {
        if (!Array.isArray(arr) || arr.length === 0) {
            return [];
        }

        return arr.map(item => this.translateService.instant(item));
    }
}
